export default __webpack_public_path__ + "static/media/triple-chevron-up.94eaad41.svg";